import { createFileRoute } from '@tanstack/react-router'

import { TrainingEditor } from '@/components/training/training-editor'
import { RETURN_SHAPE } from '@/lib/return-to'
import { exactly, readSearch } from '@/lib/search-params'

const SHAPE = {
  /** Lot 38d : les vidéos tournées, et leur publication au portail. */
  onglet: exactly('videos'),
  /** #401 : la liste d'où l'on vient, filtres compris. */
  ...RETURN_SHAPE,
}

/** Lot 38a : un scénario de formation — `web_path` `/formations/{short_id}`. */
export const Route = createFileRoute('/_app/formations/$shortId')({
  validateSearch: (search: Record<string, unknown>) => readSearch(SHAPE, search),
  component: TrainingScenarioPage,
})

function TrainingScenarioPage() {
  const { shortId } = Route.useParams()
  const { onglet } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <TrainingEditor
      key={shortId}
      shortId={shortId}
      tab={onglet === 'videos' ? 'videos' : 'scenario'}
      onTabChange={(next) => {
        void navigate({ search: next === 'videos' ? { onglet: 'videos' } : {} })
      }}
    />
  )
}
